export default __webpack_public_path__ + "static/media/geofenceMarker_Yay.e4a53af4.svg";